const TagAssignmentEndpoints = {
  EXECUTE_TAG_ASSIGNMENT: "/voc-tag-assignment-runs/",
};

export default TagAssignmentEndpoints;
